<template>
  <div>
    <div
      v-if="loading"
      class="text-center m-5">
      <Spinner/>
    </div>
    <div v-else>
      <div v-if="mfg">
        <div class="row text-center p-2">
          <img
            :src="mfg.super_buyline ? mfg.logo2 : mfg.logo"
            class="img-fluid"
            style="max-width: 10em; margin: 0 auto;">
          <!-- <div
            v-if="brands"
            class="col-12">
            <h5>Included Brands</h5>
            <div class="row">
              <div  
                v-for="b in brands"
                :key="b"
                class="col">
                <span class="text-muted w-100 m-2">
                  <h6>{{ b }}</h6>
                </span>
              </div>
            </div>
            <hr>
          </div> -->
          <div class="col-12">
            <h5 class="p-2">Minimums</h5>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="w-50">
                    <small class="text-muted">Order Value:</small>
                    {{ numeral(minDollars).format('$0,0.00') }}
                  </td>
                  <td class="w-50">
                    <small class="text-muted">Prepaid Freight:</small>
                    {{ numeral(prepaidMin).format('$0,0.00') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12 text-muted text-center my-5">
            [Text Area]
          </div>
        </div> -->
        <div class="text-center">
          <button
            class="btn btn-primary"
            data-bs-dismiss="modal"
            data-bs-target="#dropshipDetail"
            @click="browse(mfg)">
            Browse {{ mfg.super_buyline ? mfg.super_buyline_name || mfg.mfg :  mfg.mfg  }}
          </button>
        </div>
      </div>
      <div
        v-else
        class="text-center m-5">
        <h4 class="text-muted">No Data</h4>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStore } from 'vuex'
  import Spinner from '../../../../../global/Spinner.vue'

  // Initialize
  const props = defineProps(['mfg'])
  const store = useStore()

  // Methods
  const browse = (mfg)=>{
    store.dispatch('setDropshipMfg', {mfg, modal: false})
  }
  
  /* Computed */
  // Brand listing
  const brands = computed(()=>{
    if(props.mfg?.super_buyline){
      let subs = _.map(props.mfg.super_buyline, s => s.sub_buyline)
      subs.push(props.mfg.mfg.toUpperCase())
      return subs.sort()
    }
    return null
  })
  
  // Session Company
  const company = computed(()=>{
    return store.getters.sessionCompany
  })

  // Min vendor dollars required for shipment
  const minDollars = computed(()=>{
    if(props.mfg?.details){
      const min = _.find(props.mfg.details.vendor_mins, {minFunction: 'order', company: company.value})
      return min.minValue || 0
    }
    return 0
  })

  // Min order value to achieve prepaid fregiht
  const prepaidMin = computed(()=>{
    if(props.mfg?.details){
      const min = _.find(props.mfg.details.vendor_mins, {minFunction: 'prepaid', company: company.value})
      return min.minValue || 0
    }
    return 0
  })

  const loading = computed(()=>{
    return store.getters.dropshipDetailLoading
  })
</script>